<template>
    <div class="text-white bg-siteBlue form-section" data-aos="fade-up">
        <div class="container px-4 py-24 mx-auto show-on-scroll">
            <div class="mb-6 text-4xl leading-none text-center md:text-5xl title-text">
                Our Swimming Programmes
            </div>
            <div class="w-full mx-auto mb-12 text-center text-4 md:w-10/12">
                <p>Private and Small group lessons are provided for all ages. Call us to find out more!</p>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                <div class="mx-5 mt-5 mb-12" data-aos="flip-left" :data-aos-delay="(i*2)+'00'" v-for="(service, i) in services" :key="i">
                    <div class="w-full h-48 bg-center bg-cover" :style="{ backgroundImage: `url('${service.thumbnail}')` }"></div>
                    <div class="flex py-6 pr-4">
                        <div class="pr-5 text-6xl leading-none text-siteDarkBlue">{{ service.number }}</div>
                        <div class="flex flex-col ju6stify-between">
                            <div v-html="service.name" class="text-xl leading-normal text-white">{{ service.name }}</div>
                            <div class="leading-normal text-white text-4">{{ service.age }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <a href="tel:88957955" data-aos="fade-up" class="wa-btn block px-16 py-3 m-2 mx-3 font-semibold text-white bg-transparent border border-white rounded-full hover:border-gray-500 hover:text-gray-500 hover:border-transparent md:inline-block">
                    Call us at <span class="inline-block md:inline"><strong>8895 7955</strong></span>
                </a>
                <a href="#form-section" data-aos="fade-up" class="block px-16 py-3 m-2 mx-3 font-semibold text-black bg-white border border-white rounded-full hover:bg-gray-200 hover:text-gray-700 hover:border-gray-500 md:inline-block">
                    Enquire Now
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                services: [
                    {
                        thumbnail: '/images/baby-happy-swim.jpg',
                        number: '1',
                        name: 'Baby Happy Swim',
                        age: '(1 to 18 months old)'
                    },
                    {
                        thumbnail: '/images/toddler-paddler.jpg',
                        number: '2',
                        name: 'Toddler Paddler',
                        age: '(2 to 4 years old)'
                    },
                    {
                        thumbnail: '/images/swim-cruiser.jpg',
                        number: '3',
                        name: 'Swim Cruiser',
                        age: '(5 to 13 years old)'
                    }
                ]
            }
        }
    }
</script>

<style>

</style>